/**
 * Header sticky (mobile) — podaje CSS wysokość topbara.
 *
 * Na mobile cały `.hn-header` jest sticky z `top: -{wysokość topbara}`, żeby
 * topbar odjechał przy scrollu, a wiersz z logo został przyklejony. Wysokość
 * zależy od zawijania USP, więc mierzymy ją i zapisujemy w `--hn-topbar-h`.
 */
export function initHeaderSticky() {
    const header = document.querySelector('.hn-header');
    if (!header) return;

    // Header checkoutu nie ma topbara — wtedy przykleja się do samej góry.
    const topbar = header.querySelector('.hn-topbar');
    if (!topbar) {
        header.style.setProperty('--hn-topbar-h', '0px');
        return;
    }

    const sync = () => {
        header.style.setProperty('--hn-topbar-h', `${Math.round(topbar.offsetHeight)}px`);
    };

    sync();
    if (typeof ResizeObserver === 'function') {
        new ResizeObserver(sync).observe(topbar);
    } else {
        window.addEventListener('resize', sync);
    }
}
